import moment from 'moment';
import { isEmpty } from '../../utils/validators';

export const EventType = {
  CHATTERBOX: 'CHATTERBOX',
  HOUSEPARTY: 'HOUSEPARTY',
  REFUND: 'REFUND',
  HYBRID: 'HYBRID',
  CHATTERBUY: 'CHATTERBUY',
};

const HousepartyTimeLineStep = [
  {
    label: 'Applications open',
    start: 'applicationStartDate',
    end: 'applicationEndDate',
  },
  {
    label: 'Participants selected',
    start: 'noticeStartDate',
    end: 'noticeEndDate',
  },
  {
    label: 'Packs delivered',
    start: 'buildupStartDate',
    end: 'buildupEndDate',
  },
  {
    label: 'Try & share!',
    start: 'partyStartDate',
    end: 'experienceEndDate',
  },
];

const ChatterboxTimeLineStep = [
  HousepartyTimeLineStep[0],
  HousepartyTimeLineStep[1],
  {
    label: 'Try & share!',
    start: 'trialStartDate',
    end: 'trialEndDate',
  },
];

const HyBridTimeLineStep = [
  HousepartyTimeLineStep[0],
  HousepartyTimeLineStep[1],
  HousepartyTimeLineStep[2],
  {
    label: 'Try & share!',
    start: {
      strategy: 'min',
      primaryMilestone: 'partyStartDate',
      secondaryMilestone: 'trialStartDate',
      replace: 'partyStartDate',
    },
    end: {
      strategy: 'max',
      primaryMilestone: 'experienceEndDate',
      secondaryMilestone: 'trialEndDate',
      replace: 'experienceEndDate',
    },
  },
];

const getMinAndMaxDate = (getMilestones, minMax) => {
  let primary = getMilestones?.[minMax.primaryMilestone];
  let secondary = getMilestones?.[minMax.secondaryMilestone];
  if (!moment(primary).isValid()) {
    primary = null;
  }

  if (!moment(secondary).isValid()) {
    secondary = null;
  }
  if (primary && secondary) {
    return moment[minMax.strategy](moment(primary), moment(secondary)).format(
      'YYYY-MM-DD HH:mm:ss',
    );
  }
  return primary || secondary || null;
};

export const convertEventMilestonesToTimeline = (milestones, eventType) => {
  const timeLine = [];
  let actStep = 0;

  let stepConfigs;
  if (
    eventType === EventType.CHATTERBUY
    || eventType === EventType.CHATTERBOX
  ) {
    stepConfigs = ChatterboxTimeLineStep;
  } else if (eventType === EventType.HYBRID) {
    stepConfigs = HyBridTimeLineStep;
  } else {
    stepConfigs = HousepartyTimeLineStep;
  }

  const getMilestones = { ...milestones };

  stepConfigs.forEach(({ label, start, end }, index) => {
    let starts;
    if (typeof start === 'string') {
      starts = getMilestones[start];
    } else {
      starts = getMinAndMaxDate(getMilestones, start);
    }

    let ends;
    if (typeof end === 'string') {
      ends = getMilestones[end];
    } else {
      starts = getMinAndMaxDate(getMilestones, end);
    }

    if (!moment(starts).isValid()) {
      starts = null;
    }
    if (!moment(ends).isValid()) {
      ends = null;
    }
    if (starts || ends) {
      const isPresent = moment().isBetween(moment(starts), moment(ends));
      const isFuture = moment().isAfter(moment(ends || starts));

      let getDate;
      if (moment(starts).format('MMMM D') === moment(ends).format('MMMM D')) {
        getDate = moment(starts).format('MMMM D');
      } else if (!isEmpty(starts) && !isEmpty(ends)) {
          getDate = `${moment(starts).format('MMMM D')} - ${moment(ends).format(
            'MMMM D',
          )}`;
        } else if (!isEmpty(starts) && isEmpty(ends)) {
          getDate = `${moment(starts).format('MMMM D')}`;
        } else if (isEmpty(starts) && !isEmpty(ends)) {
          getDate = `${moment(ends).format('MMMM D')}`;
        }

      timeLine.push({
        date: getDate,
        text: label,
        color: (() => {
          if (isPresent) {
            actStep = index;
          } else if (isFuture) {
            actStep = index + 1;
          }
        })(),
      });
    }
  });

  return { timeLine, actStep };
};
